export const DEFAULT_ERROR_MESSAGE = 'Something went wrong, please try again';

export const DEBOUNCE_TIMEOUT = 250;
